import { jwtDecode } from "jwt-decode";

const unwrapToken = (token) => {
  if (!token || typeof token !== "string") {
    return token;
  }

  const trimmed = token.trim();
  if (trimmed.startsWith('"') && trimmed.endsWith('"')) {
    try {
      return JSON.parse(trimmed);
    } catch {
      return trimmed.slice(1, -1);
    }
  }

  return trimmed;
};

/**
 * The verifyToken function is used to verify a token.
 * @param {string} token - this is the token to verify
 */
const verifyToken = (token) => {
  if (!token) {
    return;
  }

  try {
    const decodedToken = jwtDecode(unwrapToken(token));

    const currentTime = Date.now() / 1000;
    if (decodedToken.exp < currentTime) {
      localStorage.removeItem("authToken");
      sessionStorage.removeItem("authToken");
      return;
    }

    if (decodedToken.exp > currentTime) {
      return decodedToken;
    }

    return;
  } catch (error) {
    console.error("Invalid token", error);
    return;
  }
};

export const isPortalAdmin = (decoded, sessionFlag) => {
  const values = [
    decoded?.userType,
    decoded?.IsAdmin,
    decoded?.isAdmin,
    sessionFlag,
  ];

  return values.some((value) => {
    if (value === true || value === 1) return true;
    const text = String(value ?? "").trim().toUpperCase();
    return text === "ADMIN" || text === "SUPER" || text === "TRUE" || text === "YES";
  });
};

export default verifyToken;